import { render, staticRenderFns } from "./ArtworkGuide.vue?vue&type=template&id=70eb01a8&scoped=true&"
import script from "./ArtworkGuide.vue?vue&type=script&lang=js&"
export * from "./ArtworkGuide.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkGuide.vue?vue&type=style&index=0&id=70eb01a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb01a8",
  null
  
)

export default component.exports